import React from "react";
import { TableData } from "extranet-component-library";
import { useTranslation } from "react-i18next";

interface CustomProps {
    allStops: Array<any>;
    handleAdd: (data: any) => void;
}

const AllStops = ({ allStops, handleAdd }: CustomProps) => {
    const { t } = useTranslation();

    return (
        <>
            {allStops.length ? (
                <TableData
                    rows={6}
                    items={allStops}
                    headers={[
                        { id: "cod", label: t("code") },
                        { id: "nam", label: t("name") },
                        { id: "ref", label: "" },
                        { id: "action", label: "" },
                    ]}
                    icon="star-o"
                    icon_alt="star"
                    onActionClick={(data: any) => handleAdd(data)}
                />
            ) : (
                <div className="no_items">{t("no_items")}</div>
            )}
        </>
    );
};

export default AllStops;
